import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage" }

import {useI18n} from "vue3-i18n";
import {useRouter} from "vue-router";
import {useContactService} from "@/inversify.config";
import {notifyError, notifySuccess} from "@/notify";
import {Contact} from "@/types/entities/contact";
import {IAddContactRequest} from "@/types/requests/addContactRequest";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue";
import Card from "@/components/layout/Card.vue";
import ContactForm from "@/components/forms/ContactForm.vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'AddContactForm',
  props: {
    organizationId: {}
  },
  setup(__props: any) {

const props = __props;

const {t} = useI18n()
const router = useRouter();
const contactService = useContactService()

async function handleSubmit(contact: Contact) {
    let succeededOrNotResponse = await contactService.addContact(contact as IAddContactRequest, props.organizationId)
    if (succeededOrNotResponse && succeededOrNotResponse.succeeded) {
        notifySuccess(t('validation.contact.add.success'))
        setTimeout(() => {
            router.back();
        }, 1500);
    } else {
        let errorMessages = succeededOrNotResponse.getErrorMessages('validation.contact.add');
        if (errorMessages.length == 0)
          notifyError(t('validation.contact.add.errorOccurred'))
        else
          notifyError(errorMessages[0])
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)(`routes.admin.children.organizations.addContact.name`)
    }, null, 8, ["title"]),
    _createVNode(BackLinkTitle, {
      title: _unref(t)(`routes.admin.children.organizations.addContact.name`)
    }, null, 8, ["title"]),
    _createVNode(Card, null, {
      default: _withCtx(() => [
        _createVNode(ContactForm, {
          id: props.organizationId,
          onFormSubmit: handleSubmit
        }, null, 8, ["id"])
      ]),
      _: 1
    })
  ]))
}
}

})